/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import video from "../../../Recursos/video_playa.mp4";
import fondo from "../../../Recursos/fondo_home.png";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import Tarjeta_Categorias from "../../Tarjetas/Tarjeta_Categorias";
import {CATEGORIAS} from "../../../Constantes";
import {useNavigate} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import Tarjeta_Anuncios from "../../Tarjetas/Tarjeta_Anuncios";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import {ArrowCircleDown} from "@mui/icons-material";

const Home_Portada = () => {
    const {sCell, masSM} = useResponsive()
    const refe = useRef(null);

    const navigate = useNavigate()
    const [anuncios, setAnuncios] = useState([])

    const siguientes = () => {


        if (refe.current) {
            refe.current.go('>')
        }

    }

    useEffect(() => {
        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'anuncios', wheres: w}).then((dox) => {
            setAnuncios(dox.data)
        })

    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <video width={'100%'} height={654}
                   style={{
                       objectFit: 'cover',
                       zIndex: 1,
                   }}
                   id="background-video" autoPlay loop muted poster={fondo}>
                {video &&
                    <source src={video} type="video/mp4"/>
                }
            </video>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    marginTop: -81.5,
                    zIndex: 2,
                    background: 'linear-gradient(90deg, rgba(0, 0, 0, 0.43) -0.52%, rgba(0, 0, 0, 0.00) 54.48%)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    minHeight: 650,

                }}

            >
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{maxWidth: '1400px', px: 6}}
                >


                    <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>


                            <Grid container size={{xs: 12, sm: 9, md: 9}}
                                  sx={{justifyContent: 'flex-start', mt: sCell ? 24 : 32,}}>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Splide
                                            ref={refe}
                                            aria-label="My Favorite Images" style={{width: '100%'}}
                                            options={{
                                                autoplay: true,
                                                speed: 1500,
                                                rewind: true,
                                                perPage: 1,
                                                arrows: sCell ? true : false,
                                                pagination: false,
                                                width: '100%',
                                                drag: 'free',
                                                interval: 5000,
                                                height: 350,
                                                direction: sCell ? 'ltr' : 'ttb',
                                                noDrag: true
                                            }}
                                        >

                                            {anuncios.map((item, index) => {
                                                return (
                                                    <SplideSlide key={`qe${index}`}>
                                                        <Tarjeta_Anuncios item={item}/>
                                                    </SplideSlide>
                                                )
                                            })}


                                        </Splide>
                                    </Grid>

                                    {!sCell &&
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: -16}}>
                                            <IconButton onClick={() => siguientes()}>
                                                <ArrowCircleDown sx={{fill: '#fff', height: 32, width: 32}}/>
                                            </IconButton>

                                        </Grid>
                                    }

                                </Grid>


                            </Grid>

                            <Grid container size={{xs: 12, sm: 3, md: 3}}
                                  sx={{justifyContent: 'flex-start', mt: sCell ? -16 : 39}}>
                                <Grid
                                    container
                                    justifyContent={'flex-end'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>


                                    <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                                        <Typography
                                            sx={{
                                                color: '#fff',
                                                fontSize: sCell ? 16 : 20,
                                                fontWeight: 600,
                                                lineHeight: 1.1
                                            }}>Explora
                                            nuestros
                                            Tours</Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>

                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 10}}
                                          sx={{justifyContent: 'flex-start', mt: sCell ? 1 : 0}}>
                                        <Grid
                                            container
                                            justifyContent={'center'}
                                            alignItems={'flex-start'}
                                            size={{xs: 12, sm: 12, md: 12}}
                                            spacing={sCell ? 2 : 0}
                                        >

                                            {CATEGORIAS.map((it, index) => {
                                                return (
                                                    <Grid
                                                        onClick={() => navigate('/Tours/' + it.nombre)}
                                                        container size={{xs: 6, sm: 12, md: 12}}
                                                        sx={{justifyContent: 'flex-start', mt: sCell ? 0 : 2}}>
                                                        <Tarjeta_Categorias item={it}/>
                                                    </Grid>
                                                )
                                            })}

                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Grid>


                    </Grid>


                </Grid>


            </Grid>


        </Grid>
    )

}
export default Home_Portada

